var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._t("before"),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.title))]),_c('img',{staticClass:"img",attrs:{"src":require("../assets/title.png"),"alt":"Title"}}),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }